/**
 * New typescript file
 */

import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";

declare var jQuery: any;

@Component({
    selector: 'efast-field-inputtext',
    templateUrl: 'efast-field-inputtext.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class EfastFieldInputtextComponent {

    @Input() efastFieldId: string;
    @Input() efastLabel: string;
    @Input() efastErrorMsg: string;
    @Input() efastErrorState: boolean = false;
    @Input() efastMaxLength: string;
    @Input() efastModel: string;
    @Input() efastAriaLabelledBy: string;
    @Output() efastModelChange: EventEmitter<string> = new EventEmitter<string>();
    


    constructor() {

    }
  
    ngOnInit() {

	}
    
    ngAfterViewInit() {

    }
    onInputHandler(event): void {

        this.outputEfastModel();
    }
    ngOnDestroy() {

    }
    outputEfastModel() {
        this.efastModelChange.emit(this.efastModel);
    }
}
